module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Sort#1-d8c6aca06df4fa524140f8429962d089.svg";